module.exports = __webpack_public_path__ + "static/media/hp-banner-blue-weeks.e7df04a8.png";